$(() => {
  const $button = $("[data-js-security-button]")
  const $text = $("[data-js-security-text]")

  $button.on("mouseover", (e) => {
    const $self = $(e.target)
    const index = $self.index()
    $text.removeClass("_show")
    $text.eq(index).addClass("_show")
  })
})



// WEBPACK FOOTER //
// ./src/blocks/03.security-standards/security-standards.js